import { WorkshopSection } from "./WorkshopSection";

export function WorkshopsPage() {
  return (
    <main className="min-h-screen">
      <WorkshopSection />
    </main>
  );
}
